export const ArNXMVaultEvents = {
  GetAssetsUnderManagement: 'ArNXMVault.GetAssetsUnderManagement',
  AssetsUnderManagementReturned: 'ArNXMVault.AssetsUnderManagementReturned',

  GetWithdrawableAssets: 'ArNXMVault.GetWithdrawableAssets',
  WithdrawableAssetsReturned: 'ArNXMVault.WithdrawableAssetsReturned',

  GetTotalDepositsAndWithdrawals: 'ArNXMVault.GetTotalDepositsAndWithdrawals',
  TotalDepositsAndWithdrawalsReturned:
    'ArNXMVault.TotalDepositsAndWithdrawalsReturned',

  GetAPY: 'ArNXMVault.GetAPY',
  APYReturned: 'ArNXMVault.APYReturned',

  GetAllTimeAPY: 'ArNXMVault.GetAllTimeAPY',
  AllTimeAPYReturned: 'ArNXMVault.AllTimeAPYReturned',

  GetMonthlyAPY: 'ArNXMVault.GetMonthlyAPY',
  MonthlyAPYReturned: 'ArNXMVault.MonthlyAPYReturned',

  GetProtocols: 'ArNXMVault.GetProtocols',
  ProtocolsReturned: 'ArNXMVault.ProtocolsReturned',

  Deposit: 'ArNXMVault.Deposit',
  DepositCompleted: 'ArNXMVault.DepositCompleted',

  ApprovalCompleted: 'ArNXMVault.ApprovalCompleted',

  Withdrawal: 'ArNXMVault.Withdrawal',
  WithdrawalCompleted: 'ArNXMVault.WithdrawalCompleted',

  GetWNxmValue: 'ArNXMVault.GetWNxmValue',
  WNxmValueReturned: 'ArNXMVault.WNxmValueReturned',

  FinalizeWithdraw: 'ArNXMVault.FinalizeWithdraw',
  FinalizeWithdrawCompleted: 'ArNXMVault.FinalizeWithdrawCompleted',

  GetRequestedWithdrawals: 'ArNXMVault.GetRequestedWithdrawals',
  RequestedWithdrawalsReturned: 'ArNXMVault.RequestedWithdrawalsReturned',
}
